export function getSignupErrorMessage(error) {
  switch (error) {
    case "no_user":
      return `Oh no! Something went wrong. Please verify your information is valid and try again.`;
    case "invalid_inputs":
      return `Oh no! Something went wrong with the request. Please refresh and try again.`;
    case "no_signuplist":
      return `Uh oh! We couldn't find that Signup list!`;
    case "no_item":
      return `Uh oh! We couldn't find that Signup item!`;
    case "no_network":
      return `Uh oh! Network not found!`;
    case "no_admin":
      return `Rats! It doesn't look like you have the necessary permissions to complete the Signup.`;
    case "invalid_signup_item":
      return `Uh oh! Something went wrong and we can't complete this Signup.`;
    case "signuplist_expired":
      return `Oops! This Signup is now expired!`;
    case "no_open_slots":
      return `Oh no! It doesn't look like there are enough available slots for this Signup.`;
    case "no_household":
      return `Oh no! Something went wrong finding the right household.`;
    case "no_users":
      return `We're having issues signing up those users.`;
    case "not_enough_slots":
      return `Oh no! It doesn't look like there are enough available slots for this Signup.`;
    case "no_contact_info":
      return `Oh no! It doesn't look like you have a valid email or phone. Please edit your information and try again.`;
    case "get_refund_info_error": // this is a front end only error set in the DeletePaidSignupModal
      return "Oh no! Something went wrong when we were preparing for this removal. Please try again.";
    case "payment_not_processed":
      return "Hmm! That payment hasn't processed yet and we need to wait to make a refund until it does. Please try again in a little while.";
    case "expired_refund_amount":
      return "Oh no! It looks like the refund amount changed while you were on this page. Please refresh the page and try again to get the most up to date refund amount.";
    case "max_partial_refund_amount_exceeded":
      return "Oh no! You can't refund that amount. Either process a full refund or refund less of the transaction.";
    case "invalid_refund_amount":
      return "Oh no! That refund amount is invalid. Please try again.";
    case "payment_older_than_60_days":
      return "Oh no! We can't refund payments that are older than 60 days.";
    case "invalid_payment_state":
      return "Oh no! This payment can't be refunded at the moment. Some reasons it may not be refundable are because it has been disputed, it has already been refunded, the payment was declined, or it failed.";
    case "payment_already_refunded":
      return "Oh no! Something went wrong with the refund. Please try again.";
    default:
      return `Oh no! Something went wrong trying to submit the Signup.`;
  }
}
